import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { BranchLabelHdrContainerModel } from '../../../../../../models/aggregates/erp/organisation-labels';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class BranchLabelHdrService extends BaseApiTemplateService<BranchLabelHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.ORGANISATION_PREFIX + "branch-label-hdrs/backoffice-ep";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.ORGANISATION_PREFIX + "branch-label-hdrs/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.ORGANISATION_PREFIX + "branch-label-hdrs/backoffice-ep";
    this.httpClient = http;
  }
}